import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import styled from '@mui/material/styles/styled'
import { StyledTypography } from '@components/ui/Typography/StyledTypography'

export const StyledDialog = styled(Dialog, {
  name: 'DirectBilling',
  slot: 'Dialog',
})(({ theme }) => ({
  zIndex: '12000',
  '& .MuiPaper-root': {
    borderRadius: 0,
    padding: theme.spacing(4),

    '.MuiDialogContent-root': {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },

    [theme.breakpoints.down('sm')]: {
      margin: 0,
      maxHeight: '100%',
      width: '100%',
      height: '100%',
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      borderRadius: theme.spacing(1),
      minWidth: 680,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 800,
    },
  },
}))

export const StyledDialogTitle = styled(StyledTypography, {
  name: 'DirectBilling',
  slot: 'Title',
})(({ theme }) => ({
  width: '90%',
  fontFamily: 'var(--header-title-font-family)',
  fontSize: 'var(--header-title-font-size-md)',
  fontWeight: 'var(--header-title-font-weight)',
  marginTop: theme.spacing(4),
  marginBottom: 0,
  textTransform: 'none',
  textAlign: 'center',
}))

export const StyledDialogCloseButton = styled(IconButton, {
  name: 'DirectBilling',
  slot: 'CloseButton',
})(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(4),
  right: theme.spacing(4),
  pointerEvents: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}))

export const StyledDialogActions = styled(DialogActions, {
  name: 'DirectBilling',
  slot: 'DialogActions',
})(({ theme }) => ({
  justifyContent: 'center',
  columnGap: theme.spacing(4),
  margin: `0 ${theme.spacing(3)} 0 ${theme.spacing(3)}`,

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    rowGap: theme.spacing(4),
    '& .MuiButtonBase-root': {
      margin: 0,
    },
  },
}))
